import { Tabs, type TabsProps } from "@chakra-ui/react";
import { useTabsStore } from "../stores/tabs.store";
import { forwardRef, useImperativeHandle } from "react";

export type PersistingTabIndexHandler = {
	getTab: () => number | undefined;
};

const PersistingTabIndex = forwardRef<PersistingTabIndexHandler, TabsProps>(
	({ children, id, mt }, ref) => {
		const { setTab, getTab } = useTabsStore();
		const handleSetTab = (value: number) => {
			if (id) {
				setTab(id, value);
			}
		};
		useImperativeHandle(ref, () => ({
			getTab: () => (id ? getTab(id) : undefined),
		}));
		return (
			<Tabs index={id ? getTab(id) : 0} onChange={handleSetTab} mt={mt}>
				{children}
			</Tabs>
		);
	},
);

export default PersistingTabIndex;
